import { API_COMPOSER_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type {
  Error,
  GetComposedTestCasesResponse,
  GetTestCasesParams
} from '@eggplant/types'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'

interface Props {
  params: GetTestCasesParams
  onSuccess: (response: GetComposedTestCasesResponse) => void
  onError: (error: Error) => void
  children?: () => React.ReactNode
}

const GetComposerTestCasesRequest = ({
  params,
  onSuccess,
  onError,
  children
}: Props) => {
  const url = `${API_COMPOSER_SERVICE}/test_cases`

  const { requestParams } = useGetParamsWithSpaceId<GetTestCasesParams>(params)

  return (
    <AuthenticatedDataRequest
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      params={requestParams}
      url={url}
    >
      {children}
    </AuthenticatedDataRequest>
  )
}

export default GetComposerTestCasesRequest
